// extracted by mini-css-extract-plugin
export var active = "_ib-2";
export var recordingDot = "_ib-1";
export var recordingIndicator = "_ib-0";